import { gql } from "@apollo/client";

export const FETCH_GRAPH_MODE_INFO_FOR_CHAT = gql`
    query GraphModeInfoForChat($chatId: ID!) {
        graphModeCostEstimate(chatId: $chatId)
        graphModeVariant
    }
`;


